import { getSearchPageLoadKey } from "@faire/retailer-visitor-shared/nextjs-rsc-util/getSearchPageLoadKey";
import { useSearchPageDataContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageDataContext";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageQueryParams } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";
import { shouldShowRscLoggedInSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/util/shouldShowRscLoggedInSearchPage";
import { shouldShowRscLoggedOutSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/util/shouldShowRscLoggedOutSearchPage";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { route as searchRoute } from "@faire/web-api--source/routes/search";
import { use } from "react";
import { useLocation } from "react-router-dom";
export var useSearchPageData = function() {
    var _useSearchPageDataContext = useSearchPageDataContext(), productsDataPromises = _useSearchPageDataContext.productsData, isError = _useSearchPageDataContext.isError, loading = _useSearchPageDataContext.loading, error = _useSearchPageDataContext.error, dataUpdatedAt = _useSearchPageDataContext.dataUpdatedAt, rscPageLoadKey = _useSearchPageDataContext.rscPageLoadKey;
    var _useSearchPageQueryParams = useSearchPageQueryParams(), searchQuery = _useSearchPageQueryParams.searchQuery, filters = _useSearchPageQueryParams.filters, zeroIndexedPageNumber = _useSearchPageQueryParams.zeroIndexedPageNumber, doQuerySpellCheck = _useSearchPageQueryParams.doQuerySpellCheck;
    var pageLoadKey = getSearchPageLoadKey({
        query: searchQuery,
        filters: filters,
        pageNumber: zeroIndexedPageNumber,
        doQuerySpellCheck: doQuerySpellCheck
    });
    var isSearchPage = useIsSearchPage();
    var isDiscoverPage = useSearchPageIsFromDiscoverURL();
    var productsData;
    if (productsDataPromises === null || productsDataPromises === void 0 ? void 0 : productsDataPromises.response) {
        var responsePromise = productsDataPromises === null || productsDataPromises === void 0 ? void 0 : productsDataPromises.response;
        var productTokensPromise = productsDataPromises === null || productsDataPromises === void 0 ? void 0 : productsDataPromises.productTokens;
        productsData = {
            response: use(responsePromise),
            // Product tokens are only available on logged in search/discover pages.
            productTokens: productTokensPromise ? use(productTokensPromise) : undefined
        };
    } else {
        productsData = {
            response: productsDataPromises === null || productsDataPromises === void 0 ? void 0 : productsDataPromises.legacyResponse,
            productTokens: productsDataPromises === null || productsDataPromises === void 0 ? void 0 : productsDataPromises.legacyProductTokens
        };
    }
    return {
        data: productsData,
        isFetching: loading || (shouldShowRscLoggedOutSearchPage() || shouldShowRscLoggedInSearchPage()) && // Do not show search page loading state on route change from search page to a non-search page route
        (isSearchPage || isDiscoverPage) && // Prevent infinite load on search page in legacy version
        rscPageLoadKey !== "" && rscPageLoadKey !== pageLoadKey,
        isError: isError,
        error: error,
        dataUpdatedAt: dataUpdatedAt
    };
};
var useIsSearchPage = function() {
    var location = useLocation();
    return pathMatchesRoute(location, searchRoute);
};
